import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { DeliveryPricingCard } from "./DeliveryPricing";
import { svg } from "../../../../Assets/svg";

export const SortableDeliveryPricingCard = ({ item, country, markupPercentage, isReorderMode, onDeleteSuccess }: any) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.zone_id || item._id });

  const style = {
    transform: CSS.Transform.toString(transform ? { ...transform, scaleX: 1, scaleY: 1 } : null),
    transition,
    zIndex: isDragging ? 1 : 0,
    opacity: isDragging ? 0.75 : 1,
    position: "relative" as const,
  };

  return (
    <div ref={setNodeRef} style={style} className={`mb-3 ${isDragging ? "shadow-lg rounded-4" : ""}`}>
      {isReorderMode ? (
        <div className="d-flex align-items-center">
          <div
            ref={setActivatorNodeRef}
            {...listeners}
            {...attributes}
            className="cursor-grab p-2 d-flex align-items-center justify-content-center svg-24 h-100"
            style={{
              touchAction: "none",
              WebkitTouchCallout: "none",
              WebkitUserSelect: "none",
              userSelect: "none",
              minWidth: "40px",
            }}
          >
            {svg?.dragHandleDots || "⋮⋮"}
          </div>
          <div className="flex-grow-1" style={{ pointerEvents: isDragging ? "none" : "auto" }}>
            <DeliveryPricingCard item={item} country={country} markupPercentage={markupPercentage} isReorderMode={true} onDeleteSuccess={onDeleteSuccess} />
          </div>
        </div>
      ) : (
        <DeliveryPricingCard item={item} country={country} markupPercentage={markupPercentage} onDeleteSuccess={onDeleteSuccess} />
      )}
    </div>
  );
};
